import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as models from '../../../utils/models';

class MTInspectionDataForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		surfaceCondition: Joi.string().min(3).required().label('Surface Condition'),
		testStage: Joi.string().min(3).required().label('Stage of test'),
		equipment: Joi.string().min(3).required().label('Equipment'),
		method: Joi.string().min(3).required().label('Method'),
		workOrderNo: Joi.string().required().label('Work Order No'),
		material: Joi.string().required().label('Material'),
		magneticMediumUsed: Joi.string()
			.min(3)
			.required()
			.label('Magnetic Medium Used'),
		currentUsed: Joi.string().min(3).required().label('Current Used'),
		bgContrastMediumUsed: Joi.string()
			.min(3)
			.required()
			.label('Back ground contrast medium used'),
		technique: Joi.string().min(3).required().label('Technique'),
		refStd: Joi.string().min(3).required().label('Ref Std'),
		acceptanceStd: Joi.string().min(3).required().label('Acceptance Std'),
		procedureNo: Joi.string().min(3).required().label('Procedure No'),
		summary: Joi.string().min(3).required().label('Summary'),
		remarks: Joi.string().required().label('Remarks'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.getDataWithUpdatedRemark());

		this.setState({ data: initialData });
	};

	getDataWithUpdatedRemark = () => {
		const data: any = { ...this.state.data };
		data.remarks = remarks.find((r) => r.id === data.remarks);

		return data;
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'surfaceCondition',
							label: 'Surface Condition',
							placeholder: 'Enter Surface Condition',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'testStage',
							label: 'Stage of Test',
							placeholder: 'Enter Stage of Test',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'equipment',
							label: 'Equipment',
							placeholder: 'e.g. Enter Equipment',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'method',
							label: 'Method',
							placeholder: 'Enter Inspection Method',
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'workOrderNo',
							label: 'Work Order Number',
							placeholder: 'EnterWork Order Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'material',
							label: 'Material',
							placeholder: 'Enter Inspection Material',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'magneticMediumUsed',
							label: 'Magnetic Medium Used',
							placeholder: 'Enter Magnetic Medium Used',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'currentUsed',
							label: 'Current Used',
							placeholder: 'Enter Current Used',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'bgContrastMediumUsed',
							label: 'BG contrast medium used',
							placeholder: 'Enter Background contrast medium used',
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'technique',
							label: 'Technique',
							placeholder: 'Enter Technique',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'refStd',
							label: 'Ref Standard',
							placeholder: 'Enter Ref Standard',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'acceptanceStd',
							label: 'Acceptance Standard',
							placeholder: 'Enter Acceptance Standard',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'procedureNo',
							label: 'Procedure Number',
							placeholder: 'Enter Procedure Number',
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				{this.renderTextArea({
					name: 'summary',
					placeholder: 'Enter Summary',
					label: 'Summary',
					rows: '6',
				})}

				{this.renderSelect({
					name: 'remarks',
					label: 'Remarks',
					placeholder: 'Select Remark',
					options: remarks,
				})}

				{this.renderButton('Submit Overview')}
			</form>
		);
	}
}

const remarks: models.MTInspectionRemarkItem[] = [
	{ id: 'accept', name: 'Accept', color: '#cdffc5' },
	{ id: 'reject', name: 'Reject', color: 'rgba(183, 3, 3, 0.2)' },
];

const initialData = {
	surfaceCondition: '',
	testStage: '',
	equipment: '',
	method: '',
	workOrderNo: '',
	material: '',
	magneticMediumUsed: '',
	currentUsed: '',
	bgContrastMediumUsed: '',
	technique: '',
	refStd: '',
	acceptanceStd: '',
	procedureNo: '',
	summary: '',
	remarks: '',
};

export default MTInspectionDataForm;
